import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { MatMenuItem } from '@angular/material/menu';
import { MatIconButton } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-mark-as-span-button',
  templateUrl: './mark-as-span-button.component.html',
  styleUrls: ['./mark-as-span-button.component.scss'],
  imports: [TranslateModule, MatMenuItem, MatIconButton, MatTooltip, MatIcon],
})
export class MarkAsSpanButtonComponent {
  @Input() isMenu = false;

  constructor() {}
}
